import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { FcAddImage } from 'react-icons/fc';
import classNames from 'classnames';

export const UploadDragDrop = ({ handleImages, type }) => {
  const [uploadHover, setUploadHover] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  const refUpload = useRef(null);

  const handleUploadClick = () => {
    refUpload.current.click();
  };

  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // at least one file has been dropped so do something
      // handleFiles(e.dataTransfer.files);
      const files = Array.from(e.dataTransfer.files);

      const filteredFiles = files.filter(
        file => file.type.split('/')[0] === 'image'
      );

      handleImages(filteredFiles, type);
    }
  };

  return (
    <>
      <input
        hidden
        type="file"
        name={type}
        ref={refUpload}
        onChange={e => {
          handleImages(Array.from(e.target.files), type);
          refUpload.current.value = null;
        }}
        accept="image/*"
        multiple
      />

      <div
        className={classNames(
          'w-100 rounded d-flex justify-content-center align-items-center',
          {
            'bg-soft-primary': dragActive
          }
        )}
        style={{
          border: '3px dashed var(--falcon-400)',
          aspectRatio: '1/1'
        }}
        onClick={handleUploadClick}
        onMouseEnter={() => setUploadHover(true)}
        onMouseLeave={() => setUploadHover(false)}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <div className="p-2">
          <FcAddImage
            size="50%"
            style={{
              transition: 'all 0.3s ease',
              filter: uploadHover
                ? 'drop-shadow(0px 0px 7px var(--falcon-500))'
                : ''
            }}
          />
          <p className="m-0 fs--1 fw-bold">
            Haga click o<br />
            arrastre para subir
          </p>
        </div>
      </div>
    </>
  );
};

UploadDragDrop.propTypes = {
  handleImages: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['image', 'houseMap']).isRequired
};
